import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogFooter,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/Button';
import useUpdateProvidedJobPostList from '../api/useUpdateProvidedJobPostList';
import { showSuccessToast } from '@/features/agent/job_change_processes/lib/toast';

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  listId: string;
  listName: string;
  isPublic: boolean;
}

export default function VisibilityDialog({
  open,
  onOpenChange,
  listId,
  listName,
  isPublic,
}: Props) {
  const { mutateAsync: updateList, isPending } = useUpdateProvidedJobPostList();

  const handleSubmit = async () => {
    try {
      await updateList({ id: listId, isPublic: !isPublic });
      onOpenChange(false);
      showSuccessToast(
        isPublic ? `「${listName}」を非公開にしました` : `「${listName}」を公開しました`
      );
    } catch {
      alert('公開設定の変更に失敗しました');
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-[480px] rounded-sm">
        <DialogHeader>
          <DialogTitle>{isPublic ? 'リストを非公開にする' : 'リストを公開する'}</DialogTitle>
        </DialogHeader>

        <div className="p-lg">
          <DialogDescription>
            {isPublic
              ? 'リストを非公開にすると、自分以外のユーザーから閲覧できなくなります。'
              : 'リストを公開すると、自分以外のユーザーからも閲覧できるようになります。'}
          </DialogDescription>
        </div>

        <DialogFooter>
          <div className="flex gap-2">
            <Button color="secondary" size="md" onClick={() => onOpenChange(false)}>
              キャンセル
            </Button>
            <Button color="primary" size="md" onClick={handleSubmit} disabled={isPending}>
              {isPending ? '変更中...' : isPublic ? '非公開にする' : '公開する'}
            </Button>
          </div>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
